import React from 'react';
import styled from 'styled-components';
import dt from '../../../shared/theme';

const Tag = styled.span`
  height: 14px;
  margin: 0 16px;
  padding: 0 4px;
  text-transform: uppercase;
  border: 1px solid #627484;
  box-sizing: border-box;
  border-radius: 2.4px;
  font: ${props => dt(props).theme.fontWeightBold} 10px/12px ${props => dt(props).theme.fontFamilyBody};
  color: #627484;
`;

export default function WholesaleTag() {
  return (
    <Tag className="tag-container">wholesale</Tag>
  );
}
